import Header from '@carvana/header';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import React, { memo, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderWrapper } from '|/app/header/header.styles';
import { Summary } from '|/app/services';
import UserInitializationContext from '|/app/user-initialization-context';

const defaultProps = {
  orderSummary: null as null | Summary
};

const defaultHeadProps = {
  Component: Header
};

const getChatContext = (vehicleId: number | null = null) => ({
  purchase: {
    vehicle: {
      vehicleId
    }
  }
});

function CarvanaHeader({ orderSummary } = defaultProps) {
  const {
    vehicle = null,
    vehicle: { id: vehicleId = null } = {},
    totals: { totalPrice: vehicleTotalPrice = null } = {}
  } = orderSummary || {};
  const { accessToken } = useContext(UserInitializationContext);
  const isLoggedIn = accessToken?.user?.name !== undefined;
  const location = useLocation();

  const currentRoute = (location && location.pathname) || '';
  const chatContext = vehicle === null ? null : getChatContext(vehicleId);

  const Head = memo<Partial<typeof defaultHeadProps>>(
    ({ Component = Header } = defaultHeadProps) => (
      <Component
        environment={process.env.CVNA_APP_ENVIRONMENT}
        isLoggedInExternally={isLoggedIn}
        purchaseProcessVehiclePrice={vehicleTotalPrice}
        useProvider
        currentRoute={currentRoute}
        chatContext={chatContext}
        shouldLoadPlugin={false}
      />
    )
  );

  return (
    <HeaderWrapper>
      <MfeReactComponent
        component="default"
        module="HeaderModule"
        loading={<Head />}
      >
        {({ Component: HeaderComponent }) => (
          <Head Component={HeaderComponent} />
        )}
      </MfeReactComponent>
    </HeaderWrapper>
  );
}

export default CarvanaHeader;
